import { request } from '@/utils/request';

export function fetchMoudelNames(params: any) {
  return request({
    url: '/allData/search/getModuleNames  ',
    method: 'get',
    params,
  });
}

export function fetchSearchList(data: any) {
  return request({
    url: '/allData/search/getList',
    method: 'post',
    data,
  });
}

export function fetchllmQuery(params: any) {
  return request({
    url: '/llm/knowledge/query',
    method: 'get',
    params,
    timeout: 30 * 1000,
    testenv: true,
  });
}

// export function fetchllmChat(params: any) {
//   return request({
//     url: '/llm/chat',
//     method: 'post',
//     params,
//     // timeout: 30 * 1000,
//     // testenv: true,
//   });
// }

export function fetchllmFeedback(data: any) {
  return request({
    url: '/llm/feedback',
    method: 'post',
    data,
  });
}

export function fetchllmPromptTemplate() {
  return request({
    url: '/llm/getPromptTemplate',
    method: 'get',
  });
}
